angular.module("ainapp")
    .controller("PurchaseRequestController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, window) {

            $scope.PageName = "Purchase Requests";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.init = function () {
                $scope.filter = {
                    Keyword: "",
                    IsLinkPending: false,
                };
                if ($scope.VoucherPreLoad.IsVoucherPreLoad) {
                    if ($scope.VoucherPreLoad.IsLoadPendingPreLoad) {
                        $scope.filter.IsLinkPending = true;
                    }
                    $scope.resetVoucherPreLoads();
                }
            }
            $scope.init();


            $scope.SalesSource = new kendo.data.DataSource({
                transport: {
                    read: function (o) {
                        o.data.Keyword = $scope.filter.Keyword;
                        o.data.CostKeyword = $scope.filter.CostKeyword;
                        o.data.IsLinkPending = $scope.filter.IsLinkPending;
                        MainService.PurchaseRequestInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success(false);
                            toastr.error($scope.NetworkErrorLan);
                        })
                    }
                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Date: {
                                type: "date",
                            },
                            DueDate: {
                                type: "date",
                            },
                            VoucherNumber: {
                                type: "string",
                            },
                            LinkedRefNos: {
                                type: "string",
                            },
                            "Customer.Name": {
                                type: "string",
                            },
                            TotalQuantity: {
                                type: "float",
                            },
                            NetTotal: {
                                type: "float",
                            },
                            TotalTax: {
                                type: "float",
                            },
                            GrandTotal: {
                                type: "float",
                            },
                            CalcGrandTotal: {
                                type: "float",
                            },
                            ConversionRate: {
                                type: "float",
                            },
                            CreatedDate: {
                                type: "date",
                            },
                            "CreatedBy.UserName":{
                                type: "string",
                            }
                        }
                    }
                },
                pageSize: 10,
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
            });

            $scope.SalesFactory = {
                toolbar: ["excel"],
                stretch: true,
                selectable: true,
                groupable: false,
                height: 550,
                sortable: true,
                resizable: true,
                dataSource: $scope.SalesSource,
                pageable: true,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                filterable: true,

                columns: [

                    {
                        field: "VoucherNumber",
                        title: "#",
                        headerTemplate: "{{LanguageData.vouchernumber}}",
                                            },
                    {
                        field: "LinkedRefNos",
                        title: "Linked Refs",
                    },
                    {
                        field: "Customer.Name",
                        title: "Supplier",
                        headerTemplate: "{{LanguageData.Supplier}}",
                        width: '250px'
                                            },

                    {
                        field: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "Date",
                        headerTemplate: "{{LanguageData.Date}}",
                                            },
{
                        field: "TotalQuantity",
                        title: "Total Qty", 
                        template: "<div style='text-align: right'>#=kendo.toString(TotalQuantity, 'n')#</div>",
                                            },
                    {
                        field: "NetTotal",
                        title: "Net Total",
                        headerTemplate: "{{LanguageData.NetTotal}}",
                        template: "<div style='text-align: right'>#=kendo.toString(NetTotal, 'n')#</div>",

                                            },
                    {
                        field: "TotalTax",
                        title: "Total Tax",
                        headerTemplate: "{{LanguageData.TotalTax}}",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalTax, 'n')#</div>",


                                            },


                    {
                        field: "GrandTotal",
                        title: "Grand Total",
                        headerTemplate: "{{LanguageData.GrandTotal}}",
                        template: "<div style='text-align: right'>#=kendo.toString(GrandTotal, 'n')#</div>",

                                            },
                    {
                        field: "ConversionRate",
                        title: "Conv Rate",
                        template: "<div style='text-align: right'>#=kendo.toString(ConversionRate, 'n')#</div>",
                                            },
                    {
                        field: "CalcGrandTotal",
                        title: "Calc Grand Total",
                        template: "<div style='text-align: right'>#=kendo.toString(CalcGrandTotal, 'n')#</div>",
                                            },

                                            {
                                                field: "CreatedDate",
                                                template: "#= kendo.toString(kendo.parseDate(CreatedDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                                                title: "Created Date"
                                            },
                        
                                            {
                                                field: "CreatedBy.UserName",
                                                title: "Created By"
                                            },
                                            {
                                                field: "DueDate",
                                                template: "#= kendo.toString(kendo.parseDate(DueDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                                                title: "Due Date",
                                                headerTemplate: "{{LanguageData.DueDate}}",
                                                                    },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='Delete(dataItem)'></button> <button class=' btn-default btn-sm fa fa-print'  ng-click=\"PrintInvoice(dataItem.Id, 'Purchase Request', dataItem.VoucherNumber)\"></button><button class=' btn-default btn-sm fa fa-eye'  ng-click='View(dataItem)'></button><button class=' btn-default btn-sm fa fa-link'  ng-click=\"linkVoucherModal(dataItem, 'Purchase Request')\"></button><button class=' btn-default btn-sm fa fa-file'  ng-click=\"goVoucherDocs(dataItem, 'Purchase Request')\"></button>  ",
                        width: '160px'
                        },


                                        ],
            };


            $scope.Edit = function (data) {
                $state.go("editPurchaseRequest", {
                    VoucherId: data.Id
                })
            };

            $scope.refresh = function () {
                $scope.filter = {
                    Keyword: "",
                    Type: "",
                };
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            };

            //            $scope.search = function () {
            //                $("#Sales-grid").data("kendoGrid").dataSource.read();
            //            };

            $scope.SearchKendo = function () {
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            }

            $scope.SelectedDataForDelete = {};
            $scope.Delete = function (data) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $('#deleteModal').modal('show');
                }
            }

            $scope.deleteWithConfirm = function () {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeletePurchaseRequest($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response) {
                        $scope.load = false;
                        toastr.success("Success");
                        $scope.refresh();
                        $('#deleteModal').modal('hide');
                    }
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.Print = function (data) {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.PrintPurchaseRequest($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response) {
                        $scope.load = false;
                        toastr.success("Success");
                        $scope.refresh();
                    }
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.View = function (data) {
                // $state.go("viewPurchaseRequest", {
                //     VoucherId: data.Id
                // })

                var url = $state.href('viewPurchaseRequest', {
                    VoucherId: data.Id
                });
                window.open(url, '_blank');

            }

        }])
